import { AttributesMixin, Collection, define, Model, type } from "@type-r/models";
import { CreditNoteVaultCard } from "./CreditNoteVaultCard";
import { restfulIO } from "./endpoint";

export interface CreditNotesVaultPage extends AttributesMixin<typeof CreditNotesVaultPage> { }
@define
export class CreditNotesVaultPage extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/assets');
    static idAttribute = "assetId";


    static attributes = {
        assetId: String,

        creditNotes: type({items: [CreditNoteVaultCard], count: Number }).endpoint(restfulIO('./')).dontSave,
        selected: Collection.ofRefs(CreditNoteVaultCard)
    }
}